// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__SCh3R","hand":"Home_hand__iyQLR","wave":"Home_wave__Xra+7"};